import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { TopTenHoldingModel } from '../../../Models/Models/PortfolioAnalysis/PortfolioDetails/TopTenHoldingModel';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class TopTenHoldingsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(asAt: IJsonDate, hierarchyIds: Array<string>, includeExternal: boolean, useConversionView: boolean): Promise<Array<TopTenHoldingModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Details/TopTenHoldings/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { asAt: asAt, hierarchyIds: hierarchyIds, includeExternal: includeExternal, useConversionView: useConversionView }

    return AjaxWrapper.get<Array<TopTenHoldingModel>, any>(url, data);
  }
}

